export const PAGE_LINKS = {
  home: '/',
  login: '/login',
  ruleManagement: '/rule_management',
}
